import { PDFSource } from '@stores/pdfStore'
import type { StyleSheet } from 'react-native'

interface IPdfWrapperProps {
  pdfSource: PDFSource | null
  handlePageChanged: (page: number, _totalPages: number) => void
  currentPage: number
  handleError: (error: Error | unknown) => void
  decodedUrl: string
  pdfKey: string
  password: string | undefined
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  styles: StyleSheet.NamedStyles<any>
}

export function PdfWrapper({
  // Todas as props são ignoradas na versão web
  decodedUrl,
}: IPdfWrapperProps) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
      }}
    >
      <p>Visualização de PDF não disponível na versão web.</p>
      <p>URL do documento: {decodedUrl}</p>
    </div>
  )
}
